module.exports = __webpack_public_path__ + "src/assets/img/meetingList_dension1.87ec4102.jpg";